<template>
  <div>
    <b-card class="m-3">
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="titulo-sagres font-weight-bold"
            >Corrigir dados da vaga</span
          >
          <btn-voltar />
        </h6>
      </template>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(corrigirDadosCargo)">
          <b-row>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Código"
                v-slot="defaultState"
              >
                <b-form-input
                  id="input-codigo"
                  :state="defaultState.state"
                  v-model="cargo.codigoCargo"
                  type="text"
                  disabled
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Vínculo"
                v-slot="defaultState"
              >
                <b-form-select
                  id="input-vinculo"
                  :state="defaultState.state"
                  v-model="cargo.vinculo"
                  :options="tiposVinculo"
                  @change="handleVinculoChange"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Nomenclatura"
                v-slot="defaultState"
              >
                <b-form-input
                  v-if="nomenclaturaTextoLivre"
                  v-b-tooltip.click.bottom
                  v-b-tooltip.blur.bottom
                  title="Igual ao Normativo"
                  id="input-nomenclatura"
                  :state="defaultState.state"
                  v-model="nomenclaturaInput"
                  @blur="verificarNomenclatura(nomenclaturaInput)"
                  type="text"
                />
                <b-form-select
                  v-else
                  id="select-nomenclatura"
                  :state="defaultState.state"
                  v-model="cargo.nomenclaturaCargo"
                  :options="tiposNomenclatura"
                  @change="verificarNomenclatura(cargo.nomenclaturaCargo)"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Situação da Vaga"
                v-slot="defaultState"
              >
                <b-form-select
                  id="input-situacao"
                  :state="defaultState.state"
                  v-model="cargo.situacaoCargo"
                  :options="tiposSituacao"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Escolaridade Exigida"
                v-slot="defaultState"
              >
                <b-form-select
                  id="input-escolaridade"
                  :state="defaultState.state"
                  v-model="cargo.escolaridade"
                  :options="tiposEscolaridade"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Quantidade de Vagas Existentes"
                v-slot="defaultState"
              >
                <b-form-input
                  id="input-quantidadeVagas"
                  :state="
                    defaultState.state &&
                    !isNaN(
                      parseInt(
                        cargo.quantidadeVagas.toString().replace('.', '')
                      )
                    )
                  "
                  v-model="cargo.quantidadeVagas"
                  type="text"
                  @change="checkNumeroDeVagas()"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Regime Jurídico"
                v-slot="defaultState"
              >
                <b-form-select
                  id="input-regimeJuridico"
                  :state="defaultState.state"
                  v-model="cargo.regimeJuridico"
                  :options="tiposRegimeJuridico"
                  :disabled="cargo.vinculo == null"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Natureza"
                v-slot="defaultState"
              >
                <b-form-select
                  id="input-naturezaCargo"
                  :state="defaultState.state"
                  v-model="cargo.naturezaCargo"
                  :options="tiposNatureza"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" lg="6" xl="4">
              <default-form-validation-provider
                label="Regime Previdenciário"
                v-slot="defaultState"
              >
                <b-form-select
                  id="input-regimePrevidenciario"
                  :state="defaultState.state"
                  v-model="cargo.regimePrevidenciario"
                  :options="tiposRegimePrevidenciario"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col v-if="mostrarInputCargaHoraria" cols="12" lg="6" xl="6">
              <default-form-validation-provider
                label="Carga Horária Semanal"
                v-slot="defaultState"
              >
                <b-form-input
                  id="input-cargaHoraria"
                  :state="defaultState.state"
                  v-model="cargo.cargaHoraria"
                  type="number"
                  min="1"
                  max="70"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12" xl="6">
              <default-form-validation-provider
                label="Justificativa da Correção"
                v-slot="defaultState"
              >
                <b-form-textarea
                  id="input-justificativaCorrecao"
                  :state="defaultState.state"
                  v-model="cargo.justificativaCorrecao"
                  rows="3"
                  max-rows="6"
                />
              </default-form-validation-provider>
            </b-col>
          </b-row>
          <br /><br />
          <div v-if="temNormativo" id="infoNormativoWrapper">
            <span><b>Informações do normativo</b></span>
            <b-alert
              v-if="normativoNaoEncontrado"
              show
              dismissible
              variant="warning"
            >
              <strong>Atenção! </strong>Ato Normativo não encontrado na base de
              dados. Para cadastrar um novo Ato Normativo, clique
              <button
                type="button"
                class="btnCadastroLegislacoes"
                @click="$bvModal.show('modal-cadastro-legislacao')"
              >
                aqui
              </button>
            </b-alert>
            <b-table
              :fields="camposNormativo"
              striped
              hover
              no-border-collapse
              :items="normativoAdicionado"
              small
            >
              <template v-slot:cell(actions)="">
                <div class="actions-icons">
                  <div class="wrapper-icon" @click="$bvModal.show('modal')">
                    <font-awesome-icon icon="edit" />
                    <div style="font-size: 12px">Editar</div>
                  </div>
                </div>
              </template>
            </b-table>
          </div>
          <b-row>
            <b-col>
              <b-button type="submit" class="ml-4 mr-4">
                <font-awesome-icon icon="save" class="mr-2" />Salvar
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>

    <modal-adicionar-normativo
      :tiposAtoNormativo="tiposAtoNormativo"
      :tiposVeiculoPublicacao="tiposVeiculoPublicacao"
      :normativoInicial="cargo.normativo"
      @salvar="salvarNormativo"
    />
    <modal-cadastro-legislacao @fechar="fecharModalLegislacoes" />
    <modal-nomenclatura-duplicada @sair="$router.go(-1)" />
  </div>
</template>

<script lang="ts">
import { ValidationObserver } from "vee-validate";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import cargoService from "@/services/atos-pessoal/cargoService";
import {
  carregarTipoVinculo,
  carregarTipoRegimeJuridico,
  carregarTipoRegimePrevidenciario,
  carregarTipoNatureza,
  carregarTipoEscolaridade,
  carregarTipoSituacao,
  carregarTipoAtoNormativo,
  carregarTipoVeiculoPublicacaoNormativo,
} from "./utils";
import { store } from "@/store";
import BtnVoltar from "@/components/shared/BtnVoltar.vue";
import { UtilsTS } from "@/utilsts";
import ModalAdicionarNormativo from "@/components/atos-pessoal/cargos/ModalAdicionarNormativo.vue";
import ModalCadastroLegislacao from "@/components/atos-pessoal/cargos/ModalCadastroLegislacao.vue";
import ModalNomenclaturaDuplicada from "@/components/atos-pessoal/cargos/ModalNomenclaturaDuplicada.vue";
import { Component, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { TableField } from "@/types/table-field";
import { fieldsNormativoAdicionado } from "@/types/atos-pessoal/cargos/fields-normativo-adicionado";
import { SelectValue } from "@/types/select-value";
import { NormativoCargo } from "@/types/atos-pessoal/cargos/normativo-cargo";
import { TabelasAuxiliaresCargo } from "@/types/atos-pessoal/cargos/tabelas-auxiliares-cargo";
import { CargoCorrigirDados } from "@/types/atos-pessoal/cargos/cargo-corrigir-dados";

const CompProps = Vue.extend({
  name: "CorrigirDados",
  components: {
    ValidationObserver,
    DefaultFormValidationProvider,
    BtnVoltar,
    ModalAdicionarNormativo,
    ModalCadastroLegislacao,
    ModalNomenclaturaDuplicada,
  },
  props: {
    idCargo: { type: String },
  },
});

@Component
export default class CorrigirDados extends mixins(UtilsTS, CompProps) {
  tabelasAuxiliares = new TabelasAuxiliaresCargo();
  tiposVinculo: SelectValue[] = [];
  tiposNomenclatura: SelectValue[] = [];
  nomenclaturaInput = "";
  tiposRegimeJuridico: SelectValue[] = [];
  tiposRegimePrevidenciario: SelectValue[] = [];
  tiposNatureza: SelectValue[] = [];
  tiposEscolaridade: SelectValue[] = [];
  tiposSituacao: SelectValue[] = [];
  tiposAtoNormativo: SelectValue[] = [];
  tiposVeiculoPublicacao: SelectValue[] = [];
  cargo = new CargoCorrigirDados();
  temNormativo = false;
  normativoNaoEncontrado = false;
  normativoAdicionado: any[] = [];
  nomenclaturaTextoLivre = false;
  camposNormativo: TableField[] = fieldsNormativoAdicionado;

  get mostrarInputCargaHoraria(): boolean {
    return (
      this.cargo.vinculo != 1 &&
      this.cargo.vinculo != 2 &&
      this.cargo.vinculo != 7 &&
      this.cargo.vinculo != 9 &&
      this.cargo.vinculo != 11 &&
      this.cargo.vinculo != null
    );
  }

  async carregarTabelasAuxiliares(): Promise<void> {
    const response = await cargoService.getTabelasAuxiliares();
    this.tabelasAuxiliares = response.data;
  }

  atualizarInformacoesNormativo(): void {
    const descricaoTipoAtoNormativo =
      this.cargo.normativo.tipoAtoNormativo != null
        ? this.formatTipoAtoNormativo(this.cargo.normativo.tipoAtoNormativo)
        : undefined;
    this.normativoAdicionado = [];
    this.normativoAdicionado.push({
      numeroNormativo:
        this.cargo.normativo.numeroAtoNormativo != null
          ? String(this.cargo.normativo.numeroAtoNormativo)
          : "",
      anoNormativo:
        this.cargo.normativo.anoAtoNormativo != null
          ? String(this.cargo.normativo.anoAtoNormativo)
          : "",
      veiculoNormativo: this.cargo.normativo.veiculoPublicacao,
      dtInicioVigenciaNormativo: this.formatData(
        this.cargo.normativo.dataInicioVigencia ?? ""
      ),
      tipoNormativo: descricaoTipoAtoNormativo ?? "",
    });
  }

  async salvarNormativo(dados: NormativoCargo): Promise<void> {
    this.cargo.normativo = new NormativoCargo({ ...dados });
    this.atualizarInformacoesNormativo();
    this.temNormativo = true;
    this.$bvModal.hide("modal");

    const response = await cargoService.verificarNormativo(
      this.cargo.normativo.numeroAtoNormativo,
      this.cargo.normativo.anoAtoNormativo,
      this.cargo.normativo.tipoAtoNormativo
    );
    this.normativoNaoEncontrado =
      response && response.status != 200 ? true : false;
  }

  async corrigirDadosCargo(): Promise<void> {
    try {
      this.cargo.quantidadeVagas = String(
        parseInt(this.cargo.quantidadeVagas.toString().replace(".", ""))
      );

      if (this.nomenclaturaTextoLivre) {
        this.cargo.nomenclaturaCargo = this.nomenclaturaInput;
      }

      const payload: any = { ...this.cargo };
      if (!this.temNormativo) delete payload.normativo;

      const response = await cargoService.corrigirDadosCargo(payload);
      if (response && response.status == 200) {
        this.$toast.success("Cargo salvo com sucesso");
        this.$router.push("/atos-pessoal/cargos/consulta");
      } else if (response && response.data?.erros) {
        response.data.erros.forEach((erro: string) => this.$toast.error(erro));
      } else {
        this.$toast.error("Erro ao salvar os dados");
      }
    } catch (error: unknown) {
      this.tratarError(error);
    }
  }

  formatTipoAtoNormativo(idTipo: number): string | undefined {
    const tipoAtoNormativo = this.tiposAtoNormativo.find(
      (t) => t.value == idTipo
    );
    if (tipoAtoNormativo?.text) return tipoAtoNormativo.text;
    this.$toast.error("Erro ao formatar tipo de ato normativo");
  }

  async getCargo(): Promise<void> {
    const response = await cargoService.getCargo(this.idCargo);
    if (response && response.status == 200) {
      const c = response.data;
      this.cargo.codigoCargo = c.DeCodigoCargo;
      this.cargo.nomenclaturaCargo = c.DeNomenclaturaCargo;
      this.cargo.vinculo = c.IdTipoVinculo;
      this.cargo.regimeJuridico = c.IdTipoRegimeJuridico;
      this.cargo.regimePrevidenciario = c.IdTipoRegimePrevidenciario;
      this.cargo.naturezaCargo = c.IdNaturezaCargo;
      this.cargo.especialidade = c.DeEspecialidade;
      this.cargo.area = c.DeArea;
      this.cargo.escolaridade = c.IdTipoEscolaridade;
      this.cargo.habilitacaoExigida = c.DeHabilitacaoExigida;
      this.cargo.quantidadeVagas = c.NrQuantidadeVagas;
      this.cargo.idadeMinima = c.NrIdadeMinima;
      this.cargo.idadeMaxima = c.NrIdadeMaxima;
      this.cargo.tetoRemuneratorioEspecifico = c.DeTetoRemuneratorioEspecifico;
      this.cargo.situacaoCargo = c.IdSituacaoCargo;
      this.cargo.cargaHoraria = c.NrCargaHoraria;

      if (c.Normativo.length > 0) {
        this.cargo.normativo.numeroAtoNormativo =
          c.Normativo[0].NrNumeroNormativo;
        this.cargo.normativo.anoAtoNormativo = c.Normativo[0].NrAnoNormativo;
        this.cargo.normativo.veiculoPublicacao =
          c.Normativo[0].DeVeiculoPublicacao;
        this.cargo.normativo.dataInicioVigencia =
          c.Normativo[0].DtDataInicioVigenciaNormativo;
        this.cargo.normativo.tipoAtoNormativo =
          c.Normativo[0].IdTipoAtoNormativo;
        this.atualizarInformacoesNormativo();
        this.temNormativo = true;
      }
    } else {
      this.$toast.error("Erro ao obter os dados do cargo");
      this.$router.push("/atos-pessoal/cargos/consulta");
    }
  }

  async handleVinculoChange(): Promise<void> {
    this.nomenclaturaInput = "";
    this.cargo.nomenclaturaCargo = "";
    this.nomenclaturaTextoLivre = this.cargo.vinculo
      ? [3, 4, 5, 8, 9, 13].includes(this.cargo.vinculo)
      : false;

    if (!this.nomenclaturaTextoLivre) {
      const nomenclaturas = this.tabelasAuxiliares.nomenclaturas.filter(
        (n) => n.IdVinculo == this.cargo.vinculo
      );
      this.tiposNomenclatura = [
        { value: null, text: "SELECIONE UMA OPÇÃO", disabled: true },
        ...nomenclaturas.map((n) => ({
          value: n.Descricao,
          text: n.Descricao,
        })),
      ];
    }

    if (
      this.cargo.vinculo == 12 ||
      (this.cargo.vinculo == 4 &&
        (store.codigoUG == "001111" || store.codigoUG == "002213"))
    ) {
      const naturezas = this.tabelasAuxiliares.tipoNatureza.filter(
        (n) => n.Descricao == "MILITAR"
      );
      this.tiposNatureza = [
        { value: null, text: "SELECIONE UMA OPÇÃO", disabled: true },
        ...naturezas.map((n) => ({ value: n.Id, text: n.Descricao })),
      ];
    } else {
      const naturezas = this.tabelasAuxiliares.tipoNatureza.filter(
        (n) => n.Descricao != "MILITAR"
      );
      this.tiposNatureza = [
        { value: null, text: "SELECIONE UMA OPÇÃO", disabled: true },
        ...naturezas.map((n) => ({ value: n.Id, text: n.Descricao })),
      ];
    }

    const response = await cargoService.buscarRegimesJuridicos(
      this.cargo.vinculo
    );
    if (response && response.status == 200) {
      this.tiposRegimeJuridico = [
        { value: null, text: "SELECIONE UMA OPÇÃO", disabled: true },
        ...response.data.regimesJuridicos.map((n) => ({
          value: n.IdTipoRegimeJuridico,
          text: n.DeTipoRegimeJuridico,
        })),
      ];
    } else {
      this.$toast.error("Erro ao buscar regimes jurídicos");
    }

    if (!this.mostrarInputCargaHoraria) this.cargo.cargaHoraria = null;
  }

  async carregarNomenclatura(): Promise<void> {
    const nomenclaturaOriginal = this.cargo.nomenclaturaCargo;
    await this.handleVinculoChange();
    if (this.nomenclaturaTextoLivre) {
      this.nomenclaturaInput = nomenclaturaOriginal;
    } else {
      this.cargo.nomenclaturaCargo = nomenclaturaOriginal.toUpperCase();
    }
  }

  checkNumeroDeVagas(): void {
    const min = 1;
    const max = 99999;
    const qntdVagasInt = parseInt(
      this.cargo.quantidadeVagas.toString().replace(".", "")
    );

    if (qntdVagasInt > max) this.cargo.quantidadeVagas = String(max);
    if (qntdVagasInt < min) this.cargo.quantidadeVagas = String(min);

    const rx = /(\d+)(\d{3})/;
    this.cargo.quantidadeVagas = String(this.cargo.quantidadeVagas).replace(
      /^\d+/,
      function (w) {
        while (rx.test(w)) {
          w = w.replace(rx, "$1.$2");
        }
        return w;
      }
    );
  }

  async verificarNomenclatura(value: string): Promise<void> {
    const response = await cargoService.verificarNomenclatura(value);
    if (response && response.status === 400) {
      this.$bvModal.show("modal-nomenclatura");
    } else if (!response) {
      this.$toast.error("Erro ao verificar a nomenclatura.");
    }
  }

  async fecharModalLegislacoes(enviado = false): Promise<void> {
    if (enviado) {
      this.normativoNaoEncontrado = false;
      this.$bvModal.hide("modal-cadastro-legislacao");
      return;
    }
    const response = await cargoService.verificarNormativo(
      this.cargo.normativo.numeroAtoNormativo,
      this.cargo.normativo.anoAtoNormativo,
      this.cargo.normativo.tipoAtoNormativo
    );
    this.normativoNaoEncontrado =
      response && response.status != 200 ? true : false;
    this.$bvModal.hide("modal-cadastro-legislacao");
  }

  async created(): Promise<void> {
    try {
      store.blockScreen = true;
      await this.carregarTabelasAuxiliares();
      this.tiposVinculo = carregarTipoVinculo(this.tabelasAuxiliares);
      this.tiposRegimeJuridico = carregarTipoRegimeJuridico(
        this.tabelasAuxiliares
      );
      this.tiposRegimePrevidenciario = carregarTipoRegimePrevidenciario(
        this.tabelasAuxiliares
      );
      this.tiposNatureza = carregarTipoNatureza(this.tabelasAuxiliares);
      this.tiposEscolaridade = carregarTipoEscolaridade(this.tabelasAuxiliares);
      this.tiposSituacao = carregarTipoSituacao(this.tabelasAuxiliares);
      this.tiposAtoNormativo = carregarTipoAtoNormativo(this.tabelasAuxiliares);
      this.tiposVeiculoPublicacao = carregarTipoVeiculoPublicacaoNormativo(
        this.tabelasAuxiliares
      );
      await this.getCargo();
      await this.carregarNomenclatura();
      this.checkNumeroDeVagas();
    } catch (error: unknown) {
      this.tratarError(error);
      console.error("Erro ao carregar dados do cargo:", error);
    } finally {
      store.blockScreen = false;
    }
  }
}
</script>

<style src="./css/main.css">
